// extracted by mini-css-extract-plugin
export var modalFooter = "_tn-0";